// ==============================|| OVERRIDES - PAPER ||============================== //

export default function Paper(theme) {
	return {
		MuiPaper: {
			styleOverrides: {
				root: {}
			}
		}
	}
}
